
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13.758","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon feather-heart","d":"M12.697 1.061a3.62 3.62 0 00-5.121 0l-.7.7-.7-.7a3.621 3.621 0 00-5.121 5.121l.7.7 5.122 5.121 5.121-5.121.7-.7a3.62 3.62 0 000-5.121z","fill":"#f36628"}})])
          )
        }
      }
    